import {createUseSelector} from '@packages/systems/flux';
import {LocalizationState} from '@packages/systems/localization-types';

const useLocalizationSlice = createUseSelector<{
  LocalizationStore: LocalizationState;
}>();

const selectLocalizationState = (state: {
  LocalizationStore: LocalizationState;
}) => state.LocalizationStore;

export const useLocalizationSelector = <T>(
  selector: (state: LocalizationState) => T
) => {
  const state = useLocalizationSlice(selectLocalizationState);
  return selector(state);
};
